import { Component, OnInit } from '@angular/core';
import { DataTableTypes } from 'inn-datatable';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-no-activity',
  templateUrl: './no-activity.component.html',
  styleUrls: ['./no-activity.component.css']
})
export class NoActivityComponent implements OnInit {


  noActivityTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: <DataTableTypes.Head[]>[
      { title: "Name", key: "name" },
      { title: "Total", key: "total" },
      { title: "Amount", key: "amount", pipe: "currency" },
    ],
    options: <DataTableTypes.Options>{
      // noOfRowsToDisplay: 10,
      debug: true,
      emitClickActions: [],
      singleActions: []
    }
  };

  constructor() { }

  ngOnInit() {
  }

  getNoActivity(){
    
  }

}
